/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import { LocaleLink } from "utilities/NavigationUtilities";
import { AppPath } from "components/AppPath";
import { useLocalizedGuidePage } from "hooks/useLocalizedGuidePage";

const LATEST_UPDATES_SLUG_EN = "whats-new-in-adobe-podcast-may-2025";

const LinkContainer = styled(LocaleLink)`
  text-decoration: none;
  color: var(--spectrum-gray-800);
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
`;

export const WhatsNewButton: React.FC<{ mobile?: boolean }> = ({ mobile }) => {
  const localizedGuidePath = useLocalizedGuidePage(LATEST_UPDATES_SLUG_EN);

  const content = mobile ? (
    <sp-button dir="rtl" size="xl" variant="secondary" style={{ fontSize: 18 }}>
      {I18n.t("whats_new")}
    </sp-button>
  ) : (
    <span>{I18n.t("whats_new")}</span>
  );
  return <LinkContainer to={localizedGuidePath}>{content}</LinkContainer>;
};
